import React, { useEffect } from "react"

import styles from "./Modal.module.scss"

/**
 *
 * @param {String} [className] - additional className to add to modal
 * @param {String} [overlayClassName] - additional className to add to overlay
 * @param {Function} setShowModal - function to toggle modal
 */
const Modal = props => {

    useKeyPress('Escape', () => {
        props.setShowModal(false)
    });

    const handleClose = (e) => {
        props.setShowModal(false);
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        return false;
    }

    return (
        <>
            <div className={`${styles.overlay} ${props.overlayClassName || ""}`} onClick={(e) => handleClose(e)} />
            <div className={styles.holder}>
                <div className={`${styles.modal} ${props.className || ""}`}>
                {!props.disableCloseButton &&
                    <i className={`fal fa-times ${styles["close-modal"]}`} onClick={() => props.setShowModal ? props.setShowModal(false) : null } />
                }
                    {props.children}
                </div>
            </div>
        </>
    )
}

export default Modal

export const useKeyPress = (targetKey, fn) => {
  function downHandler({ key }) {
    if (key === targetKey) {
      fn();
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  });
};
